<template>
  <section class="our-partners">
    <div class="container">
      <div class="our-partners__header flex justify-between items-center mb-4">
        <h2 class="text-xl md:text-2xl text-[#222] m-0 font-bold">
          {{ $t("partners.title") }}
        </h2>
        <div class="our-partners__navigation">
          <button
            @click="swiper.slidePrev()"
            :class="{ disabled: !canSlidePrev }"
          >
            <svg-icon name="left" />
          </button>
          <button
            @click="swiper.slideNext()"
            :class="{ disabled: !canSlideNext }"
          >
            <svg-icon name="right" />
          </button>
        </div>
      </div>

      <swiper
        :slides-per-view="1"
        :space-between="20"
        :breakpoints="breakpoints"
        :pagination="{ clickable: true }"
        class="our-partners__slider"
        @swiper="onSwiper"
      >
        <swiper-slide v-for="(partner, index) in partners" :key="index">
          <div
            class="our-partners__card border border-[#D0DADB] rounded-xl flex items-center justify-center h-[125px]"
          >
            <img
              :src="partner"
              class="object-contain max-h-[90px] max-w-[90px]"
            />
          </div>
        </swiper-slide>
      </swiper>
    </div>
  </section>
</template>

<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/pagination";

export default {
  name: "OurPartners",
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      breakpoints: {
        320: {
          slidesPerView: 1.2,
        },
        640: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 4,
          slidesPerGroup: 1,
        },
      },
      partners: [
        "https://www.muftyat.kz/media/uploads/img3_copy.png",
        "https://www.muftyat.kz/media/uploads/Zeket_LogoNoBG_vstcK3X_1.png",
        "https://www.muftyat.kz/media/uploads/%D0%9B%D0%BE%D0%B3%D0%BE_%D0%A5%D0%90%D0%9B%D0%90%D0%9B_%D0%94%D0%90%D0%9C%D0%A3_1_SHza8lk.png",
        "https://www.muftyat.kz/media/uploads/%D0%9B%D0%BE%D0%B3%D0%BE_%D0%92%D0%B0%D0%BA%D1%84_%D1%86%D0%B2%D0%B5%D1%82%D0%BD%D0%BE%D0%B9_bD9G9dC.png",
        "https://www.muftyat.kz/media/uploads/82732551_111469290395913_4996252609812627456_o_1.png",
        "https://www.muftyat.kz/media/uploads/%D0%BB%D0%BE%D0%B3%D0%BE_%D0%B7%D0%B5%D0%BB%D0%B5%D0%BD%D1%8B%D0%B82_%D0%95%D1%80%D0%BC%D1%83%D1%80%D0%B0%D1%82_1.png",
        "https://www.muftyat.kz/media/uploads/M-LOGO_FOR_VIDEO_p3Qyv0q_1.png",
        "https://www.muftyat.kz/media/uploads/UMMET.KZ_LOGO_6ZoVWXm_1.png",
        "https://www.muftyat.kz/media/uploads/5dd6a8fab1f06.jpg",
        "https://www.muftyat.kz/media/uploads/logo-sunna_Lg0aqtn.png",
        "https://www.muftyat.kz/media/uploads/Songy_1_x7mEsv9_1.png",
        "https://www.muftyat.kz/media/uploads/FB_IMG_1562771829581.jpg",
        "https://www.muftyat.kz/media/uploads/Logo_asyldin.kz.png",
        "https://www.muftyat.kz/media/uploads/%D0%BB%D0%BE%D0%B3%D0%BE_vJwo0Yc.png",
        "https://www.muftyat.kz/media/uploads/%D0%9B%D0%9E%D0%93%D0%9E%D1%82%D0%B8%D0%BF_%D0%BD%D0%BE%D0%B2%D1%8B%D0%B9.jpg",
        "https://www.muftyat.kz/media/uploads/cropped-Risunok1_1.png",
        "https://www.muftyat.kz/media/uploads/logotip_s0XaA2i_1.jpg",
        "https://www.muftyat.kz/media/uploads/original_1_AvEcfUf.png",
        "https://www.muftyat.kz/media/uploads/amin.kzlogotext_i4Tiv3P_1.png",
        "https://www.muftyat.kz/media/uploads/logo_Alashdin_MMvGNbf_1.png",
        "https://www.muftyat.kz/media/uploads/furqan_logo_2.png",
        "https://www.muftyat.kz/media/uploads/IMG_3024.PNG",
      ],
      canSlidePrev: false,
      canSlideNext: true,
      swiper: null,
    };
  },
  methods: {
    onSwiper(swiper) {
      this.swiper = swiper;

      swiper.on("slideChange", () => {
        this.canSlidePrev = !swiper.isBeginning;
        this.canSlideNext = !swiper.isEnd;
      });
    },
  },
};
</script>

<style scoped lang="scss">
.our-partners {
  @apply bg-white;

  &__header {
  }

  &__title {
    @apply text-[#222];
  }

  &__navigation {
    @apply flex items-center gap-2;
    button {
      @apply w-10 h-10 rounded-full bg-white flex items-center justify-center;
      @apply transition-all duration-300 bg-zinc-100;
      &.disabled {
        @apply opacity-50 cursor-not-allowed;
      }
    }
  }

  &__nav-btn {
    @apply transition-all duration-300;

    &--prev {
      @apply hover:bg-[#F1F1F1];
    }

    &--next {
      @apply hover:bg-white;
    }
  }

  &__slider {
    @apply pb-8;
  }

  &__card {
    @apply transition-all duration-300;
    &:hover {
      @apply shadow-sm;
    }
  }

  :deep(.swiper-pagination) {
    @apply bottom-0;
  }

  :deep(.swiper-pagination-bullet) {
    @apply w-2 h-2 bg-[#F1F1F1] opacity-100;
  }

  :deep(.swiper-pagination-bullet-active) {
    @apply bg-[#05B242];
  }
}
</style>
